import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from './core/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthMSALService } from './core/auth/msal/auth-msal.service';
import { MsalService, BroadcastService } from '@azure/msal-angular';
import { Subscription } from 'rxjs/Subscription';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  keepSubscriptionsAlive: boolean = false;
  private successSubscription: Subscription;
  private errorSubscription: Subscription;

  constructor(
    private router: Router,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    public auth: AuthService,
    private authMSAL: AuthMSALService,
    private msalService: MsalService,
    private broadcastService: BroadcastService
  ) {

    // get the landing url and use that for a redirect later on
    // console.log('get landing url', window.location.pathname);
    this.auth.returnUrl = window.location.pathname;

    // subscribe to the login failure event
    this.successSubscription = this.broadcastService
      .subscribe('msal:loginFailure', (err) => {
        this.toastrService.error('Login Failed');
        console.log('login failure ' + JSON.stringify(err));
        // this.loggedIn = false;
      });

    // subscribe to the login event
    this.errorSubscription = this.broadcastService
      .subscribe('msal:loginSuccess', (payload) => {
        // console.log('login success ' + JSON.stringify(payload));
        this.authMSAL.checkLoginOnRedirect();
      });

  }

  ngOnInit() {

    // Silently check if the user is already logged in
    this.authMSAL.checkLoginOnRedirect(false);

  }

  ngOnDestroy() {
    this.broadcastService.getMSALSubject().next(1);
    if (this.successSubscription) { this.successSubscription.unsubscribe(); }
    if (this.errorSubscription) { this.errorSubscription.unsubscribe(); }
  }



}



// WEBPACK FOOTER //
// ./client/app/app.component.ts